import * as CallLoggerDialogConstants from '../constants/CallLoggerDialog';
import {Patient} from "../../../models/Patient";

const initialState: {
  isDisplayed: boolean,
  callStartedAt: Date | null,
  patient: Patient | null
  selectedGuideId?: string
} = {
  isDisplayed: false,
  callStartedAt: null,
  patient: null,
  selectedGuideId: null
};

export function callLogger(state = initialState, action) {
  switch (action.type) {
    case CallLoggerDialogConstants.START_CALL_LOGGING:
      return {...state, isDisplayed: true, callStartedAt: new Date(), patient: action.patient, selectedGuideId: action.selectedGuideId};
    case CallLoggerDialogConstants.STOP_CALL_LOGGING:
      return {...state, isDisplayed: false, callStartedAt: null, patient: null};
    case CallLoggerDialogConstants.SWITCH_INTERVIEW_GUIDE:
      return {...state, selectedGuideId: action.selectedGuideId};
    default:
      return state;
  }
}
